import React from 'react';
import styled from 'styled-components';
import {
  white,
  screenMdMin,
  screenSmMax,
} from '@spotify-internal/encore-foundation';
import {
  LogoSpotifyForArtists,
  VisuallyHidden,
} from '@spotify-internal/encore-web';

type LogoProps = {
  condensed?: boolean;
};

const StyledLogo = styled(LogoSpotifyForArtists).attrs((props: LogoProps) => ({
  height: props.condensed ? 28 : 36,
  color: white,
  'aria-label': 'Spotify for Artists',
}))`
  @media (max-width: ${screenSmMax}) {
    display: ${(props: LogoProps) => (props.condensed ? 'initial' : 'none')};
  }

  @media (min-width: ${screenMdMin}) {
    display: ${(props: LogoProps) => (props.condensed ? 'none' : 'initial')};
  }
`;

export const ResponsiveLogo: React.FC = () => {
  return (
    <>
      <StyledLogo />
      <StyledLogo condensed />
      <VisuallyHidden>Spotify for Artists</VisuallyHidden>
    </>
  );
};
